import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/app.css';
import '../css/index.css';
import '../css/disenoGlobal.css';

class Header extends React.Component{


  menuDesplegable(){
    //$(this).children().show();
    document.getElementById('#nosotrosHeader').style.display='block'; 
  };
  //,function(){
    //$(this).children('div').hide();
    //$(this).show();
  //});

  render(){
    return(
<div id="globalContent" className="container-fluid">
    

    <div className="row align-items-center">
      <div className="col-10 offset-1 col-sm-8 offset-sm-2 col-md-4 offset-md-0 col-lg-3 text-center">
    <br />
    <a href="https://www.antp.org.mx/" style={{ marginTop: '20px', marginBottom: '20px'}}><img width="65%" className="img-fluid" src="https://www.antp.org.mx/nd_img/Logotipo-ANTP-azul (2).png"></img></a>
    <br /><br />
  </div>
      <div className="col-md-4 offset-md-4 col-lg-3 offset-lg-6 hidden-sm-down">
    <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel" data-interval="5000">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <p className="text-right align-middle d-block w-100" style={{ paddingRight: '10px', fontSize: '14px'}}>
            <br />
            Cambio Climático y Desarrollo Urbano
            <br />
            <a target="_blank" href="https://blog.antp.org.mx/cambio-climatico-y-desarrollo-urbano/" className="text-info" style={{ marginRight:'2%'}}>Leer más...</a>
            <br /><br />
          </p>
        </div>
        <div className="carousel-item">
          <p className="text-right align-middle d-block w-100" style={{paddingRight: '10px', fontSize: '14px'}}>
            <br />
            Y la Marina Mercante Mexicana APA por lo menos la de Cabotaje
            <br />
            <a target="_blank" href="https://blog.antp.org.mx/y-la-marina-mercante-mexicana-apa-por-lo-menos-la-de-cabotaje/" className="text-info" style={{ marginRight:'2%;'}}>Leer más...</a>
            <br /><br />
          </p>
        </div>
        <div className="carousel-item">
          <p className="text-right align-middle d-block w-100" style={{paddingRight: '10px', fontSize: '14px;'}}>
            <br />
            Encuentro de Transporte y Logística 2019 ETYL
            <br />
            <a target="_blank" href="https://blog.antp.org.mx/encuentro-de-transporte-y-logistica-2019-etyl/" className="text-info" style={{ marginRight:'2%'}}>Leer más...</a>
            <br /><br />
          </p>
        </div>
      </div>
      
    </div>
  </div>
    </div>
    
  <div className="row">
    <div id="headerMenu" className="bg-primary hidden-lg-up col">
      <nav className="navbar navbar-default navbar-toggleable-md navbar-inverse bg-primary" style={{ position: 'relative'}}>
        <div className="row" style={{ width: '100%' }}>
          <div className="text-center col-6 col-sm-12">
            <p style={{ paddingTop: '10px', marginTop:' 0px', paddingBottom: '0px', marginBottom: '0px'}}></p>
            <a  href="http://es-la.facebook.com/antpmx/" target="_blank" className="text-white iconosRedes"><i className="fab fa-facebook-f colorFacebook"></i></a>&nbsp;&nbsp;&nbsp;
            <a  href="http://twitter.com/antpmexico?lang=es" target="_blank" className="text-white iconosRedes"><i className="fab fa-twitter colorTwitter"></i></a>&nbsp;&nbsp;&nbsp;
            <a  href="http://www.youtube.com/channel/UCQceWYoxh0kiHnQUhKttUTA" target="_blank" className="text-white iconosRedes"><i className="fab fa-youtube colorYoutube"></i></a>&nbsp;&nbsp;&nbsp;
            <a href="https://www.instagram.com/antp_mx/" className="text-white iconosRedes" target="_blank"><i className="fab fa-instagram colorMessenger"></i></a>&nbsp;&nbsp;&nbsp;
            <a href="http://api.whatsapp.com/send?phone=5215555343598&text=%C2%A1Hola!" className="text-white iconosRedes" target="_blank"><i className="fab fa-whatsapp colorWhats"></i></a>
          </div>
        </div>
        <button id="menuHamburguesa"  className="navbar-toggler navbar-toggler-right text-white" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="true" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon text-white"></span>
        </button>
        <p style={{paddingTop: '0px', marginTop: '0px', paddingBottom: '10px', marginBottom: '0px'}}></p>
        <div className="collapse navbar-collapse" id="navbarCollapse" >
          <ul className="navbar-nav mr-auto">
            <li  className="nav-item active">
             <a  className="nav-link nav-link-menu" aria-haspopup="true" aria-expanded="true">&nbsp;</a>
            </li>
            <li className="nav-item active botonInicio">
              <a className="nav-link nav-link-menu" href="https://www.antp.org.mx/" aria-haspopup="true" aria-expanded="false">INICIO</a>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li id="#nosotrosHeader" className="nav-item dropdown active" onmouseenter="menuDesplegable" >
             <a  className="nav-link nav-link-menu" href="https://www.antp.org.mx/nosotros"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >NOSOTROS</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01" style={{position: 'absolute'}}>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#quienesSomos">¿QUIÉNES SOMOS?</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#misionYVision">MISIÓN Y VISIÓN</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#objetivos">OBJETIVOS</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#nuestroEquipo">NUESTRO EQUIPO</a>
              </div>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item dropdown active">
              <a  id="#comunicacionHeader" className="nav-link nav-link-menu" href="https://www.antp.org.mx/comunicacion"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">COMUNICACIÓN</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01">
                <a  className="dropdown-item" href="https://www.antp.org.mx/comunicacion#live">LIVE</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/comunicacion#revista">REVISTA</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/comunicacion#cursos">CURSOS</a>
              </div>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item dropdown active">
              <a  id="#eventosHeader" className="nav-link nav-link-menu" href="https://www.antp.org.mx/eventos"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">EVENTOS</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01">
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#pabellon">AUDITORIO DE DISTRIBUCIÓN Y TRANSPORTE</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#fntm">FORO NACIONAL DEL TRANSPORTE DE MERCANCÍAS</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#congreso">CONGRESO NACIONAL EN SEGURIDAD VIAL</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#pnsv">PREMIO NACIONAL DE SEGURIDAD VIAL</a>
              </div>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item dropdown active">
              <a  id="#comitesHeader" className="nav-link nav-link-menu" href="/comites"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">COMITÉS</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01">
                <a  className="dropdown-item" href="https://www.antp.org.mx/comites#cnsv">COMITÉ NACIONAL DE SEGURIDAD VIAL</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/comites#cpcd">COMITÉ PREVENCIÓN Y COMBATE AL DELITO</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/comites#cdd">COMITÉ DE MOVILIDAD</a>
              </div>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item active">
              <a  className="nav-link nav-link-menu" href="https://www.antp.org.mx/socios"   aria-haspopup="true" aria-expanded="false">SOCIOS</a>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item active">
              <a  className="nav-link nav-link-menu" href="https://www.antp.org.mx/smap"   aria-haspopup="true" aria-expanded="false">SMAP</a>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item active">
              <a  className="nav-link nav-link-menu" href="https://blog.antp.org.mx/" target="_blank"  aria-haspopup="true" aria-expanded="false">BLOG</a>
            </li>
            <hr style={{margin: '1px', marginColor: '#ffffff', border: 'solid #ffffff 1px'}} />
            <li  className="nav-item active">
              <a  className="nav-link nav-link-menu" href="https://www.antp.org.mx/contacto"  aria-haspopup="true" aria-expanded="false">CONTACTO</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div id="headerMenu" className="text-center bg-primary hidden-md-down col">
      <nav style={{display: 'inline-block'}} className="navbar navbar-toggleable-md navbar-inverse  bg-primary">
        <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse movil" id="navbarCollapse" >
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active botonInicio">
              <a className="nav-link nav-link-menu" href="https://www.antp.org.mx/"   aria-haspopup="true" aria-expanded="false">INICIO</a>
            </li>
            <li className="nav-item active hidden-md-down botonInicio">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item dropdown active menuDesplegable">
              <a id="nosotrosHeader" className="nav-link nav-link-menu" href="https://www.antp.org.mx/nosotros"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">NOSOTROS</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01" style={{opacity: '0.8'}}>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#quienesSomos">¿QUIÉNES SOMOS?</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#misionYVision">MISIÓN Y VISIÓN</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#objetivos">OBJETIVOS</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/nosotros#nuestroEquipo">NUESTRO EQUIPO</a>
              </div>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item dropdown active menuDesplegable">
              <a id="comunicacionHeader" className="nav-link nav-link-menu" href="https://www.antp.org.mx/comunicacion"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">COMUNICACIÓN</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01" style={{opacity: '0.8'}}>
                <a className="dropdown-item" href="https://www.antp.org.mx/comunicacion#live">LIVE</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/comunicacion#revista">REVISTA</a>
                <a className="dropdown-item" href="https://www.antp.org.mx/comunicacion#cursos">CURSOS</a>
              </div>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item dropdown active menuDesplegable">
              <a id="eventosHeader" className="nav-link nav-link-menu" href="https://www.antp.org.mx/eventos"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">EVENTOS</a>
              <div className="dropdown-menu" aria-labelledby="dropdown01" style={{opacity: '0.8'}}>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#pabellon">AUDITORIO DE DISTRIBUCIÓN Y TRANSPORTE</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#fntm">FORO NACIONAL DEL TRANSPORTE DE MERCANCÍAS</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#congreso">CONGRESO NACIONAL EN SEGURIDAD VIAL</a>
                <a  className="dropdown-item" href="https://www.antp.org.mx/eventos/#pnsv">PREMIO NACIONAL DE SEGURIDAD VIAL</a>
              </div>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link nav-link-menu" href="https://www.antp.org.mx/comites"   aria-haspopup="true" aria-expanded="false">COMITES</a>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link nav-link-menu" href="https://www.antp.org.mx/socios"   aria-haspopup="true" aria-expanded="false">SOCIOS</a>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link nav-link-menu" href="https://www.antp.org.mx/smap"   aria-haspopup="true" aria-expanded="false">SMAP</a>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link nav-link-menu" href="https://blog.antp.org.mx/" target="_blank"  aria-haspopup="true" aria-expanded="false">BLOG</a>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link nav-link-menu" href="https://www.antp.org.mx/contacto" aria-haspopup="true" aria-expanded="false">CONTACTO</a>
            </li>
            <li className="nav-item active hidden-md-down">
              <a className="nav-link">|<span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link text-white" target="_blank" href="https://es-la.facebook.com/antpmx/"><i className="fab fa-facebook-f colorFacebook"></i><span className="sr-only"></span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link text-white" target="_blank" href="https://twitter.com/antpmexico?lang=es"><i className="fab fa-twitter colorTwitter" aria-hidden="true"></i><span className="sr-only"></span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link text-white" target="_blank" href="https://www.youtube.com/channel/UCQceWYoxh0kiHnQUhKttUTA"><i className="fab fa-youtube colorYoutube" aria-hidden="true"></i><span className="sr-only"></span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link text-white" target="_blank" href="https://www.instagram.com/antp_mx/"><i className="fab fa-instagram colorMessenger"></i><span className="sr-only"></span></a>
            </li>
            <li className="nav-item active">
              <a className="nav-link text-white" target="_blank" href="https://api.whatsapp.com/send?phone=5215555343598&text=%C2%A1Hola!"><i className="fab fa-whatsapp colorWhats" aria-hidden="true"></i><span className="sr-only"></span></a>
            </li>
          </ul>
        </div>
      </nav>
      <br />
</div>
    </div>
    </div>
    

    );
  }
}

export default Header;